import backArrow from '../../../assets/img/backArrow.png';
import { useEffect, useState, useContext } from 'react';
import { getMimeType, getFileIcon, stringifyDict } from 'utils/util';
import api from 'api';
import { Spin, message, Select, Space } from 'antd';
import { get } from 'utils/fetch';
import { DeleteConfirmation } from 'components/DeleteConfirmation';
import { GlobalContext } from 'GlobalContext';
import { isPhoneSize, isAdmin } from 'utils/util';

export function Files(props) {
    const { setView } = props;
    const { accessToken, manageRecordId, refreshSession } =
        useContext(GlobalContext);
    const [messageApi, contextHolder] = message.useMessage();
    const [files, setFiles] = useState([]); // files newly uploaded
    const [documentTypeDict, setDocumentTypeDict] = useState({});
    const [existingFiles, setExistingFiles] = useState([]); // files already in S3
    const [loading, setLoading] = useState(true);
    const [fileNameToDelete, setFileNameToDelete] = useState('');
    const [fileIdToDelete, setFileIdToDelete] = useState(-1);
    const [showDeletionBox, setShowDeletionBox] = useState(false);
    const documentTypes = ['Investor reports', 'Tax docs'];

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    const triggerFileInput = () => {
        document.getElementById('fileInput').click(); // Trigger file input click
    };

    useEffect(() => {
        var documentTypeDict = {};
        for (const file of existingFiles) {
            documentTypeDict[file.id] = file.type;
        }
        setDocumentTypeDict(documentTypeDict);
    }, [existingFiles]);

    async function fetchFiles() {
        await get(
            api.file.fetchInvestorFiles(manageRecordId),
            setExistingFiles,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        setLoading(false);
    }

    useEffect(() => {
        fetchFiles();
    }, []);

    async function saveFiles() {
        setLoading(true);
        // setDocumentTypeDict({})
        // Create a FormData object
        const formData = new FormData();
        // formData.append('files', files.map(file => new File([file.blob], file.filename, { type: 'application/pdf' })))
        files.map((file) =>
            formData.append(
                'files',
                new File([file[0].blob], file[0].filename, {
                    type: getMimeType(file[0].filename),
                })
            )
        );
        formData.append('existingFileTypes', stringifyDict(documentTypeDict));
        formData.append(
            'newFileTypes',
            stringifyDict(
                files.reduce((acc, cur) => {
                    acc[cur[0].filename] = cur[1];
                    return acc;
                }, {})
            )
        );
        formData.append('investorId', manageRecordId);
        setFiles([]);
        // Send the files
        const emailResponse = await fetch(api.file.addInvestorFiles, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            body: formData,
        });
        fetchFiles();
        refreshSession();
        const emailResult = await emailResponse.json();
    }

    const handleFileChange = (e) => {
        var newFiles = [];
        for (var i = 0; i < e.target.files.length; i++) {
            const curFile = e.target.files[i];
            if (curFile) {
                // Generate a temporary URL for the file
                const tempUrl = URL.createObjectURL(curFile);
                newFiles.push([
                    {
                        filename: curFile.name,
                        url: tempUrl,
                        blob: curFile,
                    },
                    '',
                ]); // Allow multiple files to be uploaded
            }
        }
        setFiles([...files, ...newFiles]);
    };

    async function deletionCallback() {
        const options = {
            method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
                investorId: manageRecordId,
                fileNameToDelete,
                fileIdToDelete,
            }),
        };
        const result = await fetch(api.file.deleteInvestorFiles, options);
        refreshSession();
        // const data = await result.json()
        setLoading(true);
        setShowDeletionBox(false);
        fetchFiles();
    }

    return (
        <>
            <div
                style={{
                    margin: '20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <img
                    style={{ width: '15px', height: '20px', cursor: 'pointer' }}
                    src={backArrow}
                    onClick={() => setView('investor')}
                ></img>
            </div>
            {loading && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <Spin />
                </div>
            )}

            {!loading && (
                <>
                    {showDeletionBox && (
                        <DeleteConfirmation
                            title={`File: ${fileNameToDelete}`}
                            setShowDeletionBox={setShowDeletionBox}
                            deletionCallback={deletionCallback}
                        />
                    )}
                    {isAdmin() && (
                        <div
                            style={{ alignSelf: 'center', marginLeft: '10px' }}
                        >
                            <button
                                style={{
                                    height: '30px',
                                    width: '70px',
                                    borderRadius: '30px',
                                    background: 'rgb(17 32 86)',
                                    color: 'white',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    placeContent: 'center',
                                }}
                                onClick={triggerFileInput}
                            >
                                Add File
                            </button>
                        </div>
                    )}

                    {existingFiles.map((file, id) => {
                        return (
                            <div
                                key={id}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                }}
                            >
                                <a
                                    href={file.url}
                                    key={id}
                                    target="_blank"
                                    rel="noreferrer noopener"
                                >
                                    <div
                                        key={id}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            fontSize: '15px',
                                            color: 'black',
                                        }}
                                    >
                                        <div
                                            style={{
                                                padding: '5px',
                                                paddingBottom: '0',
                                            }}
                                        >
                                            {getFileIcon(file.url)}
                                        </div>
                                        {file.url.substring(
                                            file.url.lastIndexOf('/') + 1
                                        )}
                                    </div>
                                </a>

                                {isAdmin() ? (
                                    <span>
                                        <Select
                                            showSearch
                                            mode="tag"
                                            style={
                                                isPhoneSize()
                                                    ? {
                                                          width: '300px',
                                                      }
                                                    : {
                                                          width: '300px',
                                                          marginLeft: '5px',
                                                      }
                                            }
                                            placeholder="select file category"
                                            defaultValue={[file.type]}
                                            onChange={(e) =>
                                                setDocumentTypeDict({
                                                    ...documentTypeDict,
                                                    [file.id]: e,
                                                })
                                            }
                                            options={documentTypes.map(
                                                (type) => ({
                                                    label: type,
                                                    value: type,
                                                    desc: type,
                                                })
                                            )}
                                            optionRender={(option) => (
                                                <Space>
                                                    <span
                                                        role="img"
                                                        aria-label={
                                                            option.data.label
                                                        }
                                                    >
                                                        {option.data.emoji}
                                                    </span>
                                                    {option.data.desc}
                                                </Space>
                                            )}
                                        />
                                    </span>
                                ) : (
                                    <span
                                        style={{
                                            fontSize: '15px',
                                            alignContent: 'center',
                                            marginLeft: '20px',
                                        }}
                                    >
                                        {file.type}
                                    </span>
                                )}

                                {isAdmin() && (
                                    <span
                                        style={{
                                            marginLeft: '10px',
                                            alignContent: 'center',
                                            fontWeight: 'bold',
                                            color: '#FF0000',
                                            fontSize: '15px',
                                            cursor: 'pointer',
                                        }}
                                        className="remove-btn"
                                        onClick={() => {
                                            setFileNameToDelete(
                                                file.url.substring(
                                                    file.url.lastIndexOf('/') +
                                                        1
                                                )
                                            );
                                            setFileIdToDelete(file.id);
                                            setShowDeletionBox(true);
                                        }}
                                    >
                                        &times;
                                    </span>
                                )}
                            </div>
                        );
                    })}

                    {files && (
                        <div>
                            {files.map((file, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                    }}
                                >
                                    <a
                                        href={file[0].url}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        {/* <iframe src={pdfUrl} width="100%" height="600px" title="PDF Preview" /> */}
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                fontSize: '15px',
                                                color: 'black',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    padding: '5px',
                                                    paddingBottom: '0',
                                                    fontSize: '20px',
                                                }}
                                            >
                                                {getFileIcon(file[0].filename)}
                                                {/* <img src={PdfIcon} style={{ width: "14px" }}></img> */}
                                            </div>
                                            {file[0].filename}
                                        </div>
                                    </a>

                                    <span>
                                        <Select
                                            showSearch
                                            mode="tag"
                                            style={
                                                isPhoneSize()
                                                    ? {
                                                          width: '300px',
                                                      }
                                                    : {
                                                          width: '300px',
                                                          marginLeft: '5px',
                                                      }
                                            }
                                            placeholder="select file category"
                                            defaultValue={[file[1]]}
                                            onChange={(e) =>
                                                setFiles(
                                                    files.map(
                                                        (file, fileIdx) => {
                                                            if (
                                                                idx !== fileIdx
                                                            ) {
                                                                return file;
                                                            }
                                                            return [file[0], e];
                                                        }
                                                    )
                                                )
                                            }
                                            options={documentTypes.map(
                                                (type) => ({
                                                    label: type,
                                                    value: type,
                                                    desc: type,
                                                })
                                            )}
                                            optionRender={(option) => (
                                                <Space>
                                                    <span
                                                        role="img"
                                                        aria-label={
                                                            option.data.label
                                                        }
                                                    >
                                                        {option.data.emoji}
                                                    </span>
                                                    {option.data.desc}
                                                </Space>
                                            )}
                                        />
                                    </span>

                                    <span
                                        style={{
                                            marginLeft: '10px',
                                            alignContent: 'center',
                                            fontWeight: 'bold',
                                            color: '#FF0000',
                                            fontSize: '15px',
                                            cursor: 'pointer',
                                        }}
                                        className="remove-btn"
                                        onClick={() =>
                                            setFiles(
                                                files.filter(
                                                    (_, i) => i !== idx
                                                )
                                            )
                                        }
                                    >
                                        &times;
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}

                    {isAdmin() && (
                        <div
                            style={{
                                margin: '20px',
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <button
                                style={{
                                    height: '30px',
                                    width: '50px',
                                    borderRadius: '30px',
                                    background: 'rgb(17 32 86)',
                                    color: 'white',
                                    cursor: 'pointer',
                                }}
                                onClick={saveFiles}
                            >
                                Save
                            </button>
                        </div>
                    )}

                    <input
                        id="fileInput"
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        style={{ display: 'none' }} // Hide the default file input
                    />
                </>
            )}
        </>
    );
}
